import {SellpiaDom as _} from "./SellpiaDom";
import {StockViewBase} from "./StockViewBase";

export class StockView extends StockViewBase {
    constructor(props) {
        super(props);
    }

    createLayout({options, last_update, makeshop_product}) {
        let container = _.div(['layer-pop']);
        let body;
        this.shadow = _.div();
        this.shadow.style(
            "position: absolute;" +
            "top:0px;" +
            "left:0px;" +
            "width:100%" +
            "height:100%"
        );

        let style = this.writeStyle();
        let header = this.createHeader(last_update);

        if (options.find(option => option.pos) !== undefined) {
            body = this.createBodyPos(options, this.getOptionHeader(makeshop_product.option_category));
        } else {
            body = this.createBody(options, this.getOptionHeader(makeshop_product.option_category));
        }

        let a = (new _('a', 'l-close layer-close'));
        a.dom.addEventListener("click", () => {
            this.closeLayout();
        });

        this.main = _.div().add(_.div('l-stock-comm').style("display:none;").add(_.div('layer')
            .add(container.adds([
                style, a, header, body
            ]))));
        _.attachBody(this.main, this.shadow);
    }

    createBody(options, headers) {
        return _.div("l-cont").add(_.div("l-tbl-wrap").adds([
            _.table().attrs({'border': "0", 'summary': ""}).add([
                (new _("caption")),
                (new _("colgroup")).add(headers.map((header) => {
                    return (new _("col")).attrs({"width": 710 / (headers.length + 1)});
                })).add([
                    (new _("col")).attrs({"width": "*"}),
                ]),
                (new _("thead")).add(
                    _.tr().add(
                        headers.map(option_header => {
                            return _.th_c(_.txt_c(option_header.title));
                        })
                    ).add(_.th_c(_.txt_c('재고현황')))
                ),
                (new _("tbody")).add(
                    options.map(option => {
                        return _.tr().add(
                            option.title.map(item => {
                                let td = _.td().add(_.txt_c(item.title));
                                if (item.row > 1) {
                                    td.attrs({'rowspan': item.row});
                                }
                                return td;
                            })
                        ).add(
                            _.td().add(this.getStatusDom(option)) // 재고현황
                        );
                    })
                )
            ]),
            this.createfoot()
        ]))
    }

    createBodyPos(options, headers) {
        return _.div("l-cont").add(_.div("l-tbl-wrap").adds([
            _.table().attrs({'border': "0", 'summary': ""}).add([
                (new _("caption")),
                (new _("colgroup")).add(headers.map((header) => {
                    return (new _("col")).attrs({"width": 540 / (headers.length + 1)});
                })).add([
                    (new _("col")).attrs({"width": "*"}),
                    (new _("col")).attrs({"width": 80}),
                    (new _("col")).attrs({"width": 90})
                ]),
                (new _("thead")).add([
                        _.tr().add([
                            _.th_c(_.txt_c("온라인")).attrs({"colspan": headers.length + 1}).addClass("line-btm-gray line-right-black"),
                            _.th_c(_.txt_c("오프라인")).attrs({"colspan": 2}).addClass("line-btm-gray")
                        ]),
                        _.tr().add(
                            headers.map(option_header => {
                                return _.th_c(_.txt_c(option_header.title));
                            })
                        ).add([
                            _.th_c(_.txt_c('재고현황')).addClass("line-right-black"),
                            _.th_c(_.txt_c('오프라인')).addClass("line-right-black line-right-gray"),
                            _.th_c(_.txt_c('매장재고')),
                        ])
                    ]
                ),
                (new _("tbody")).add(
                    options.map(option => {
                        return _.tr().add(
                            option.items.filter(item => item).map(item => {
                                let td = _.td().add(_.txt_c(item.title));
                                if (item.row > 1) {
                                    td.attrs({'rowspan': item.row});
                                }
                                return td;
                            })
                        ).add(((option) => {
                                let stock_status = _.td().add(this.getStatusDom(option)).addClass("line-right-black"); // 재고현황

                                if (option.pos_sell === true) {
                                    return [
                                        stock_status,
                                        _.td().add(_.txt_c("구매가능", "s-order on")),
                                        _.td().add(_.txt_c(_.a("s-order-map on layer-open", "#layer-stock-map").text("매장확인").click((event) => {
                                            this.show_pos(option);
                                        }))),
                                    ]
                                } else if (option.pos_sell === false) {
                                    return [
                                        stock_status,
                                        _.td().add(_.txt_c("구매불가", "s-order off")),
                                        _.td().add(_.txt_c(_.a("s-order-map off layer-open", "#layer-stock-map").text("매장확인"))),
                                    ]
                                } else if (option.pos_sell === null) {
                                    return [
                                        stock_status,
                                        _.td().add(_.txt_c(" ")),
                                        _.td().add(_.txt_c(" ")),
                                    ]
                                }
                            })(option)
                        );
                    })
                )
            ]),
            this.createfoot()
        ]))
    }

    writeStyle() {
        return _.style(this.options?.css_file||"https://sellpia-product.makeshop.co.kr/publish/css/StockView.css")
    }
}
